import React, { useEffect, useState } from "react";
import "../styles/Gallery.scss";
import img1 from '../assets/gallery/1.PNG';
import img2 from '../assets/gallery/2.jpeg';
import img3 from '../assets/gallery/3.jpg';
import img4 from '../assets/gallery/4.jpg';
import img5 from '../assets/gallery/5.png';
import img6 from '../assets/gallery/6.jpg';
import img7 from '../assets/gallery/7.PNG';
import img8 from '../assets/gallery/8.jpg';
import g1 from '../assets/gallery/g1.jpg';
import g2 from '../assets/gallery/g2.jpg';
import g3 from '../assets/gallery/g3.jpg';
import g4 from '../assets/gallery/g4.jpg';
import h1 from '../assets/h1.png';


const Gallery = () => {
  const videos = [
    { title: "Wide Roads", img: g2 },
    { title: "Yoga", img: g3 },
    { title: "Morning walks", img: g1 },
    { title: "Glimpse", img: img1 },
    { title: "Luxury villa", img: img2 },
    { title: "Foggy peaks", img: h1 },
    { title: "Misty Waterfalls", img: img3 },
    { title: "Luxury Living", img: g4 },
    { title: "Peace", img: img4 },
    { title: "Luxury Living", img: img5 },
    { title: "Resort style", img: img6 },
    { title: "Shirota Dam", img: img7 },
    { title: "Mountain Views", img: img8 },


  ];

  const [activeIndex, setActiveIndex] = useState(0);

  // Auto slide every 4s
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 4000);
    return () => clearInterval(interval);
  }, [activeIndex]);

  const prevSlide = () => {
    setActiveIndex((prev) =>
      prev === 0 ? videos.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    setActiveIndex((prev) =>
      prev === videos.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <section id="gallery"
      className="gallery-section"
      style={{
        backgroundImage: `url(${videos[activeIndex].img})`,
      }}
    >
      <div className="overlay"></div>
      <div className="content">
        <h4 className="subheading">FRAMED BY NATURE</h4>
        <h1 className="heading"> Experience Lonavalley</h1>
        <p className="description">
          From lush greens to modern living — see what awaits you at Lonavalley
        </p>
        <div className="nav-buttons">
          <button className="nav-btn" onClick={prevSlide}>‹</button>
          <button className="nav-btn" onClick={nextSlide}>›</button>
        </div>
      </div>

      <div className="video-section">
        <h2 className="video-heading">Top Views</h2>
        <div className="video-carousel">
          {videos.map((video, index) => {
            let position = "nextSlide";
            if (index === activeIndex) {
              position = "activeSlide";
            } else if (
              index === activeIndex - 1 ||
              (activeIndex === 0 && index === videos.length - 1)
            ) {
              position = "prevSlide";
            }

            return (
              <div className={`video-card ${position}`} key={index}>
                <img src={video.img} alt={video.title} />
                <div className="video-info">
                  <p>{video.title}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
